import { render, staticRenderFns } from "./EditExtruder.vue?vue&type=template&id=addd7ad4&scoped=true"
import script from "./EditExtruder.vue?vue&type=script&lang=js"
export * from "./EditExtruder.vue?vue&type=script&lang=js"
import style0 from "./EditExtruder.vue?vue&type=style&index=0&id=addd7ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addd7ad4",
  null
  
)

export default component.exports